var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Autoplay, EffectCreative, EffectFade, Lazy, Pagination, Swiper } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";
export var makeSliderController = function () {
    var s = {
        init: function () {
            s.initAnimatedScroll();
            s.initFrontPageSwiper();
            s.initCertificationSwiper();
        },
        initAnimatedScroll: function () {
            var elementInView = function (el, dividend) {
                if (dividend === void 0) { dividend = 1; }
                var elementTop = el.getBoundingClientRect().top;
                return (elementTop <=
                    (window.innerHeight || document.documentElement.clientHeight) /
                        dividend);
            };
            var displayScrollElement = function (element) {
                element.classList.add("visible");
            };
            var handleScrollAnimation = function () {
                var scrollElements = document.querySelectorAll(".js-scroll:not(.visible)");
                // Removes listener.
                // Works best if no more scroll elements are added via JS.
                // Unless you add more before array.length === 0.
                if (scrollElements.length === 0) {
                    window.removeEventListener("scroll", handleScrollAnimation);
                }
                scrollElements.forEach(function (el) {
                    if (elementInView(el, 1.25)) {
                        displayScrollElement(el);
                    }
                });
            };
            window.addEventListener("scroll", handleScrollAnimation);
            handleScrollAnimation();
        },
        initCertificationSwiper: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                new Swiper('.certification-swiper', {
                    modules: [Autoplay, EffectFade],
                    loop: true,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 5280,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                });
                return [2 /*return*/];
            });
        }); },
        initFrontPageSwiper: function () { return __awaiter(void 0, void 0, void 0, function () {
            var targetEl, heroEl, swiperHeadings, slideTransitionDuration, slideAutoplayInterval, swiper;
            return __generator(this, function (_a) {
                targetEl = ".swiper-full-page";
                heroEl = document.querySelector(targetEl);
                if (!heroEl) {
                    // console.warn(targetEl, "does not exist in DOM.");
                    return [2 /*return*/];
                }
                swiperHeadings = document.querySelectorAll(".swiper-slide .heroSectionHeaderHeading");
                slideTransitionDuration = 1618;
                slideAutoplayInterval = 5280;
                swiper = new Swiper(targetEl, {
                    // @ts-ignore
                    modules: [Autoplay, EffectCreative, Pagination, Lazy],
                    autoHeight: false,
                    height: 100,
                    slidesPerView: 2,
                    spaceBetween: 20,
                    allowTouchMove: true,
                    simulateTouch: true,
                    grabCursor: true,
                    loop: true,
                    speed: slideTransitionDuration,
                    autoplay: {
                        delay: slideAutoplayInterval,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 6,
                        }
                    },
                    preloadImages: false,
                    lazy: {
                        loadPrevNext: true,
                        checkInView: true,
                    },
                });
                return [2 /*return*/];
            });
        }); },
    };
    return s;
};
var SliderController = makeSliderController();
export default SliderController;
